exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#timedout-layout {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n#timedout-layout > * p {\n  text-align: center;\n}\n#timedout-layout .container-img {\n  height: 30rem;\n}\n#timedout-layout .container-img img {\n  width: 100%;\n}", ""]);

// exports
